'use strict';

import React from 'react';
import { render } from 'react-dom';
import AppContainer from './base/AppContainer';
import Urls from './definitions/Urls';
import {
  configure,
  configureLogging,
  getFrontendProperties,
} from './definitions/Config';

configureLogging({
  prod: {
    logging: {
      level: 'ERROR',
      moduleIdLevels: [
        {
          moduleId: './src/components/agreement/Agreement.js',
          level: 'INFO',
        },
      ],
    },
  },
  dev: {
    logging: {
      level: 'ERROR',
      moduleIdLevels: [
        {
          moduleId: './src/api/*',
          level: 'DEBUG',
        },
      ],
    },
  },
});

configure({
  frontendProperties: window.omataysPortlet.frontendProperties,
  versionInfo: {
    buildNumber: window.omataysPortlet.buildNumber,
    gitProperties: window.omataysPortlet.gitProperties,
  },
  features: window.omataysPortlet.features,
});

// initialize Urls
Urls.setLogoutRedirectUrl(getFrontendProperties().logoutRedirectUrl);
Urls.setBaseUrl(getFrontendProperties().baseUrl);
Urls.setApiUrl(getFrontendProperties().apiUrl);
Urls.setMedixineApiUrl(getFrontendProperties().formsBaseUrl);
Urls.setLogoutFallbackUrl(getFrontendProperties().logoutFallbackUrl);
Urls.setOmavointiRedirectUrl(getFrontendProperties().omavointiRedirectUrl);
Urls.setGtiTargetUrl(getFrontendProperties().gtiTargetUrl);

const root = document.getElementById('omatays-portlet-main');

render(<AppContainer />, root);
